import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Sentry from '@sentry/react';
import { getMe, sec } from '../Services/vulcan';
import {
  isAuthenticated, setAccount, setAccounts, setMemberRole, setUser,
} from '../store/account';
import { useLazyGetOrgMeQuery } from '../Services/orgApi';

const Auth = ({ children }) => {
  const logged = useSelector(isAuthenticated);
  const dispatch = useDispatch();
  const [getOrgMe] = useLazyGetOrgMeQuery();

  useEffect(() => {
    getMe().then((rta) => {
      if (rta.status === 401) {
        window.location.href = '/app/login';
      } else if (rta.status === 200) {
        rta.json().then((user) => {
          const accounts = `${user['custom:accounts'] || ''}`
            .split(',')
            .map((a) => a.trim())
            .filter(Boolean);
          const stored = window.localStorage.getItem('submize_account');
          const account = (stored && accounts.includes(stored)) ? stored : accounts[0];
          sec.setAccount(account);
          dispatch(setUser(user));
          dispatch(setAccount(account));
          dispatch(setAccounts(accounts));
          getOrgMe().then(({ data: orgMe }) => {
            dispatch(setMemberRole(orgMe.role || 'admin'));
          });
          Sentry.setUser({
            id: user.user,
            ip_address: '{{ auto }}',
          });
        });
      } else {
        console.error('unknowd response', rta);
      }
    });
  }, []);
  return logged ? children : null;
};
export default Auth;
